import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'

export function Logout() {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const run = async () => {
      await signOut()
      navigate('/', { replace: true })
    }
    run()
  }, [navigate, signOut])

  return null
}


